// Reducer pour les actions basiques (couleurs, navigation, match start)
import { MatchState, MatchAction } from '../../types';
import * as matchStorage from '../../storage/matchStorage';

export function handleBasicActions(state: MatchState, action: MatchAction): MatchState | null {
  switch (action.type) {
    case 'SET_PLAYER_COLOR':
      return {
        ...state,
        [`player${action.player}Color`]: action.color
      };
    
    case 'START_MATCH':
      return {
        ...state,
        currentScreen: 'during',
        matchStarted: true,
        matchStartTime: null,
        gameStartTime: null
      };
    
    case 'ROLLBACK':
      if (state.history.length > 0) {
        const previousState = state.history[state.history.length - 1];
        
        // ✅ NOUVEAU : Vérifier que previousState a une structure valide
        if (!previousState || !previousState.gameScores) {
          console.warn('⚠️ État historique invalide, rollback ignoré');
          return state;
        }
        
        const newHistory = state.history.slice(0, state.history.length - 1);

        // Vérifier si la dernière ligne du tableau actuel contient une décision STROKE
        // Dans ce cas, il faut aussi retirer cette ligne du pointsTable restauré
        if (state.pointsTable.length > 0) {
          const lastEntry = state.pointsTable[state.pointsTable.length - 1];

          if (lastEntry.decision && ['STROKE', 'CS', 'CG'].includes(lastEntry.decision)) {
            // Retirer la ligne STROKE du pointsTable restauré
            return {
              ...previousState,
              pointsTable: (previousState.pointsTable || []).slice(0, -1),
              history: newHistory
            };
          }
        }

        // Rollback normal pour tous les autres cas
        return {
          ...previousState,
          history: newHistory
        };
      }
      return state;
    
    case 'GO_TO_AFTER':
      return {
        ...state,
        currentScreen: 'after'
      };
    
    case 'ROLLBACK_TO_DURING':
      // ✅ CORRECTION : Effectuer un VRAI rollback + changer l'écran
      if (state.history.length > 0) {
        const previousState = state.history[state.history.length - 1];
        
        // Vérifier la validité de l'état précédent
        if (!previousState || !previousState.gameScores) {
          console.warn('⚠️ État historique invalide pour ROLLBACK_TO_DURING');
          return {
            ...state,
            currentScreen: 'during' // Au moins changer l'écran
          };
        }
        
        const newHistory = state.history.slice(0, state.history.length - 1);
        
        // ✅ RESTAURER COMPLÈTEMENT l'état précédent ET changer l'écran
        return {
          ...previousState,
          currentScreen: 'during', // ← FORCER le retour à l'écran 'during'
          history: newHistory,     // ← IMPORTANT : Retirer l'état utilisé de l'historique

          // 🧹 Nettoyer les états temporaires pour éviter les incohérences
          pendingDecision: null,
          pendingDecisionLineIndex: null,

          // 🎯 S'assurer que les états essentiels sont restaurés
          matchEnded: false,       // ← Le match n'est plus terminé
          winner: null            // ← Plus de gagnant
        };
      }
      
      // Si pas d'historique, juste changer l'écran (fallback)
      console.warn('⚠️ Aucun historique disponible pour ROLLBACK_TO_DURING');
      return {
        ...state,
        currentScreen: 'during'
      };
    
    case 'ROLLBACK_TO_BEFORE':
      return {
        ...state,
        currentScreen: 'before'
      };
    
    case 'UPDATE_MATCH_INFO':
      return {
        ...state,
        matchInfo: {
          ...state.matchInfo,
          ...action.matchInfo
        }
      };

    case 'SET_ACTIVE_TIMER':
      return {
        ...state,
        activeTimer: action.timer
      };

    case 'PAUSE_TIMER':
      if (!state.activeTimer || state.activeTimer.pausedAt) return state;
      return {
        ...state,
        activeTimer: { ...state.activeTimer, pausedAt: Math.floor(Date.now() / 1000) }
      };

    case 'RESUME_TIMER':
      if (!state.activeTimer || !state.activeTimer.pausedAt) return state;
      const pauseDuration = Math.floor(Date.now() / 1000) - state.activeTimer.pausedAt;
      return {
        ...state,
        activeTimer: {
          ...state.activeTimer,
          startedAt: state.activeTimer.startedAt + pauseDuration,
          pausedAt: null
        }
      };

    case 'START_NEW_MATCH':
    // Nettoyer toutes les données de match
    matchStorage.clearAll();
    
    // Forcer le rechargement vers MatchSetupScreen
    // En nettoyant le storage, l'app détectera qu'il n'y a plus de données
    setTimeout(() => {
      window.location.reload();
    }, 100);
    
    return state; // État inchangé car on va recharger
    
    default:
      return null; // Action non gérée par ce reducer
  }
}